/* eslint-disable max-lines */
import fetch from './fetch';

const LOGIN = '/mypertamina/v2/admin/login';
const FORGOT_PASSWORD = '/mypertamina/v1/admin/reset-password';
const RESET_PASSWORD = '/password';
const MERCHANT_TYPES = '/merchantapp/v1/merchant-type';
const REGISTRATION_CSV_BULK = '/mypertamina/v1/users/bulk';
const UPDATE_PRICE_CSV_BULK = '/mypertamina/v1/admin/price-list/bulk';
const LIST_CATEGORY_FAQ = '/faqs/v1/myptm/faq/categories';
const LIST_FAQ = '/faqs/v1/myptm/faq/controlling';
const DETAIL_FAQ = `/faqs/v1/myptm/`;
const USER_PERMISSION_ENDPOINT = '/mypertamina/v1/admin/permition';
const USER_ROLE_ENDPOINT = '/mypertamina/v1/admin/role';
const USER = '/mypertamina/v1/admin/user';
const USER_V2 = '/mypertamina/v2/admin/user';
const USER_V3 = '/mypertamina/v3/admin/user';
const LIST_BANK = '/mypertamina/v1/banks';
const SYNC_STOCK_MERCHANT = '/mypertamina/v1/simelon/sync/file';
const MFA_ENDPOINT = '/mypertamina/mfa/v1/totp';
const AREA_MANAGEMENT_ENDPOINT = '/mypertamina/v1/region';
const LOGIN_IDAMAN = '/mypertamina/v1/admin/login/idaman';
const INFORMATION_SUBSIDY = '/mypertamina/products/v1/subsidy/price';
// const MOCK_API_PATH = 'https://e334004d-39b8-411d-9381-020e7720b931.mock.pstmn.io';

export const basicAuthRoutes = [
  LOGIN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  MERCHANT_TYPES,
  LIST_CATEGORY_FAQ,
  LIST_FAQ,
  DETAIL_FAQ,
  LIST_BANK,
  LOGIN_IDAMAN,
];

export const loginUser = async (data) => await fetch.post(LOGIN, data);

export const loginIdaman = async (accessToken) =>
  await fetch.post(LOGIN_IDAMAN, { accessToken });

export const logoutUser = async () =>
  await fetch.post('/mypertamina/v1/admin/logout');

export const summaryTransaction = async (startDate, endDate) =>
  await fetch.get('/mypertamina/v2/admin/summary-report', {
    params: { startDate, endDate },
  });

export const productStock = async (params = {}) =>
  await fetch.get('/mypertamina/v1/admin/stock-report', {
    params,
  });

export const summaryTransactionDetails = async (
  startDate,
  endDate,
  categoryId = '',
) =>
  await fetch.get('/mypertamina/v2/admin/product-report', {
    params: { categoryId, startDate, endDate },
  });

export const templateHet = async (region = '', provinceId = '', cityId = '') =>
  await fetch.get('/mypertamina/v1/admin/price-list/template', {
    params: { region, provinceId, cityId },
  });

export const listSbm = async (params) =>
  await fetch.get('mypertamina/v1/admin/sbm', { params });

export const listAgents = async (search = '') =>
  await fetch.get('mypertamina/v1/admin/agens', { params: { search } });

export const listRegionals = async () =>
  await fetch.get('mypertamina/v1/admin/regionals');

export const listProvinces = async (params) =>
  await fetch.get('mypertamina/v1/admin/provinces', { params });

export const listCities = async (params) =>
  await fetch.get('/mypertamina/v1/admin/cities', { params });

export const listDistricts = async (params) =>
  await fetch.get('/mypertamina/v1/admin/districts', { params });

export const listVillages = async (params) =>
  await fetch.get('/mypertamina/v1/admin/villages', { params });

export const listSam = async (params) =>
  await fetch.get('/mypertamina/v1/admin/sam', { params });

export const listProductsCategories = async () =>
  await fetch.get('/mypertamina/v1/admin/categories');

export const listProducts = async (categoryId) => {
  return await fetch.get(`/products/v1/myptm/admin/${categoryId}/products`);
};

export const basePrice = async () =>
  await fetch.get('/mypertamina/v1/admin/price-list/general');

export const getTermCondition = async (agreementId) =>
  await fetch.get(`/mypertamina/agreement/v1/terms/${agreementId}`);

export const getTermConditionById = async (agreementId) =>
  await fetch.get(`/mypertamina/agreement/v1/terms-history/${agreementId}`);

export const getTermConditionHistory = async (params) =>
  await fetch.get(`/mypertamina/agreement/v1/terms-history`, { params });

export const updateTermCondition = async (params) =>
  await fetch.put(`/mypertamina/agreement/v1/terms/1`, params);

export const getSubPangkalanTermCondition = async () =>
  await fetch.get(`/mypertamina/agreement/v1/terms/2`);

export const updateSubPangkalanTermCondition = async (agreementId, params) => {
  return await fetch.put(`/mypertamina/agreement/v1/terms/${agreementId}`, params);
};

export const listCategoryFaq = async (params) =>
  await fetch.get(LIST_CATEGORY_FAQ, { params });

export const listCategoryFaqV2 = async (params) =>
  await fetch.get(`/faqs/v2/myptm/faq/categories`, { params });

export const detailFaq = async (id) =>
  await fetch.get(`${DETAIL_FAQ}${id}/faq`);

export const deleteFaq = async (id) =>
  await fetch.delete(`${DETAIL_FAQ}${id}/faq`);

export const deleteFaqV2 = async (id) =>
  await fetch.delete(`/faqs/v2/myptm/faq/${id}`);

export const uploadImageFaq = async (file) =>
  await fetch.post(`/faqs/v1/myptm/image-faq`, file);

export const listFaq = async (params) => await fetch.get(LIST_FAQ, { params });

export const listFaqV2 = async (params) =>
  await fetch.get(`/faqs/v2/myptm/faq`, { params });

export const reorderFaq = async (category, faqIds) => {
  return await fetch.put(`/faqs/v2/myptm/faq/order/${category}`, faqIds);
};

export const chartReport = async (params = {}) =>
  await fetch.get('/mypertamina/v1/admin/chart-report', { params });

export const dataOutlet = async (params = {}) =>
  await fetch.get('/mypertamina/v2/admin/outlets', { params });

export const outletTransactions = async (params = {}) =>
  await fetch.get('/mypertamina/v2/admin/transaction-agent-report', { params });

export const getUpdateStockMerchant = async (params = {}) =>
  await fetch.get(SYNC_STOCK_MERCHANT, { params });

export const syncStockMerchant = async (historyId) =>
  await fetch.get(`${SYNC_STOCK_MERCHANT}/${historyId}`);

export const postUploadFileSyncStockMerchant = async (payload) =>
  await fetch.post(SYNC_STOCK_MERCHANT, payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const requestGenerateOutletReport = async (params = {}) =>
  await fetch.get('/mypertamina/v2/admin/download-outlets', {
    params,
  });

export const checkGeneratedOutletReport = async (cancelToken, params = {},) => {
  return fetch.get('/mypertamina/v2/admin/download-outlets/get-file-excel', {
    params,
    cancelToken,
  });
};

export const requestGenerateRegistrationReport = async (params = {}) =>
  await fetch.get('/mypertamina/v2/admin/registration/merchant-list-download', {
    params,
  });

export const checkGeneratedRegistrationReport = async (
  cancelToken,
  params = {},
) => {
  return fetch.get(
    '/mypertamina/v2/admin/registration/merchant-list-download/get-file-excel',
    {
      params,
      cancelToken,
    }
  );
};

export const outletTransactionReport = async (outletId = '', date = '') =>
  await fetch.get('/mypertamina/v1/admin/download-transaction-agent', {
    params: { outletId, date },
  });

export const detailOutlet = async (outletId = '') =>
  await fetch.get(`/mypertamina/v1/admin/${outletId}/outlet`);

export const salesReportChart = async (params = {}) => {
  const { categoryId } = params;

  let url = '/mypertamina/v1/admin/selling-report';
  if (categoryId === 'non-pertamina') {
    url = '/mypertamina/v1/admin/selling-report-nonpertamina/chart';
    delete params.categoryId;
  }
  return await fetch.get(url, {
    params,
  });
};

export const salesReportDetail = async (params = {}) => {
  const { categoryId } = params;
  let url = '/mypertamina/v2/admin/selling-report-detail';

  if (categoryId === 'non-pertamina') {
    url = '/mypertamina/v1/admin/selling-report-nonpertamina';
    delete params.categoryId;
  }

  return await fetch.get(url, {
    params,
  });
};

export const downloadSalesReport = async (params = {}) =>
  await fetch.get('/mypertamina/v1/admin/download-selling-report', {
    params,
  });

export const requestGenerateSalesReport = async (
  type = 'excel',
  params = {}
) => {
  const { categoryId } = params;

  let url =
    type === 'excel'
      ? '/mypertamina/v2/admin/download-selling-report-excel'
      : '/mypertamina/v2/admin/download-selling-report-pdf';
  if (categoryId === 'non-pertamina') {
    url =
      type === 'excel'
        ? '/mypertamina/v1/admin/selling-report-nonpertamina/generate-excel'
        : '/mypertamina/v1/admin/selling-report-nonpertamina/generate-pdf';
    delete params.categoryId;
  }

  return fetch.get(url, {
    params,
  });
};

export const checkGeneratedSalesReport = async (
  cancelToken,
  type = 'excel',
  params = {}
) => {
  const { categoryId } = params;
  let url =
    type === 'excel'
      ? '/mypertamina/v2/admin/selling-report/get-file-excel'
      : '/mypertamina/v2/admin/selling-report/get-file-pdf';
  if (categoryId === 'non-pertamina') {
    url =
      type === 'excel'
        ? '/mypertamina/v1/admin/selling-report-nonpertamina/get-excel'
        : '/mypertamina/v1/admin/selling-report-nonpertamina/get-pdf';
    delete params.categoryId;
  }

  return fetch.get(url, {
    params,
    cancelToken,
  });
};

export const paymentMethodReport = async (range = 'week') =>
  await fetch.get('/mypertamina/v2/admin/payment-method-report', {
    params: { range },
  });

export const bestSelling = async (startDate, endDate) =>
  await fetch.get('/mypertamina/v1/admin/best-selling', {
    params: { startDate, endDate },
  });

export const productPrices = async (params = { categoryId: '' }) =>
  await fetch.get('/mypertamina/v1/admin/price-list', { params });

export const subUserProductPrices = async (params = { categoryId: '' }) =>
  await fetch.get('/mypertamina/v1/admin/subuser/price-list', { params });

export const getSubUserActivationList = async (params = {}) =>
  await fetch.get('/mypertamina/v1/admin/subuser/policies', { params });

export const productPriceByCity = async (categoryId = '', cityId = '') =>
  await fetch.get('/mypertamina/v1/admin/city-price-list', {
    params: { categoryId, cityId },
  });

export const updateProductPrices = async (
  data = { cityId: '', products: [] }
) => await fetch.put('/mypertamina/v1/admin/price-list', data);

export const updateSubUserProductPrices = async (data) =>
  await fetch.put('/mypertamina/v1/admin/subuser/price-list', data);

export const updateSubUserProductPricesBySubUserId = async (payload) =>
  await fetch.post('/mypertamina/v1/admin/subuser/price-list/whitelist', payload);

export const getSubUserByRegistrationId = async (registrationId) =>
  await fetch.get(`/mypertamina/v1/admin/subuser/price-list/whitelist?search=${registrationId}`);

export const forgotPassword = async (email) =>
  await fetch.get(`${FORGOT_PASSWORD}/${email}`);

export const expiredPassword = async (email) =>
  await fetch.get(`${FORGOT_PASSWORD}/expire/${email}`);

export const resetPassword = async (data) =>
  await fetch.put(`/mypertamina/v1/admin/password`, data);

export const merchantTypes = async () => await fetch.get(MERCHANT_TYPES);

export const getDetailAdmin = async () =>
  await fetch.get(`/mypertamina/v1/admin/profile`);

export const getCustomerByTransaction = async (transactionId) =>
  await fetch.get('/mypertamina/v1/transaction/get-customer', {
    params: { transactionId },
  });

export const merchantRegistrations = async (params = {}) =>
  await fetch.get('/mypertamina/v1/admin/merchants/inject-success', {
    params,
  });

export const failedmerchantRegistrations = async (params = {}) =>
  await fetch.get('/mypertamina/v1/admin/merchants/inject-failed', {
    params,
  });

export const auditlog = async (params = {}) =>
  await fetch.get('/mypertamina/v3/admin/audit-logs', {
    params,
  });

export const auditLogFilterActions = async (params = {}) =>
  await fetch.get('/mypertamina/v1/admin/audit-logs/filter/actions', {
    params,
  });

export const auditLogFilterEmails = async (params = {}) =>
  await fetch.get('/mypertamina/v1/admin/audit-logs/filter/emails', {
    params,
  });

export const downloadAudit = async (params = {}) =>
  await fetch.get('/mypertamina/v3/admin/audit-logs/download', {
    params,
  });

export const failedMerchantRegistrationDetail = async (registrationId) =>
  await fetch.get(
    `/mypertamina/v1/admin/merchants/inject-failed/${registrationId}`
  );

export const downloadFailedRegistration = async (params) =>
  await fetch.get(`/mypertamina/v1/admin/merchants/inject-failed/download`, {
    params,
  });

export const merchantRegistrationDetail = async (registrationId) =>
  await fetch.get(
    `/mypertamina/v1/admin/merchants/inject-success/${registrationId}`
  );

export const syncMerchantMonica = async (id) =>
  await fetch.get(`/mypertamina/v1/admin/merchants/${id}/sync`);

export const agenHistory = async (userId, params) =>
  await fetch.get(
    `/mypertamina/v1/admin/merchants/${userId}/agen`, { params }
  );

export const approveMerchantRegistration = async (registrationId) =>
  await fetch.post(
    `/mypertamina/v1/admin/merchant-registrations/${registrationId}/approve`
  );

export const rejectMerchantRegistration = async (registrationId, reason) =>
  await fetch.post(
    `mypertamina/v1/admin/merchant-registrations/${registrationId}/reject`,
    {
      reason,
    }
  );

export const revitionMerchantRegistration = async (registrationId, reason) =>
  await fetch.post(
    `mypertamina/v1/admin/merchant-registrations/${registrationId}/need-revision`,
    {
      reason,
    }
  );

export const processVerification = async (params = {}) =>
  await fetch.post(
    '/mypertamina/v1/admin/merchant-registrations/process',
    params
  );

export const saveFaq = async (params = {}) =>
  await fetch.post('/faqs/v1/myptm/faq', params);

export const updateFaq = async (id, params = {}) =>
  await fetch.put(`/faqs/v1/myptm/${id}/faq`, params);

export const registrationMerchantCSVBulk = async (file) =>
  await fetch.post(REGISTRATION_CSV_BULK, file);

export const uploadBulkPrice = async (file) =>
  await fetch.post(UPDATE_PRICE_CSV_BULK, file, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const uploadBulkPriceSubUser = async (file) =>
  await fetch.post('/mypertamina/v1/admin/subuser/price-list/whitelist/bulk', file, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const manualLoggingActivation = async (params = {}) =>
  await fetch.get('/mypertamina/v1/admin/transaction/manual', { params });
export const settingManualActivation = async (params) =>
  await fetch.get('/mypertamina/v1/admin/automatic-activations', { params });

export const downloadManualLogging = async (params) =>
  await fetch.get('/mypertamina/v1/admin/transaction/manual/download', {
    params,
  });

export const manualLoggingSubmissionProcess = async (payload) =>
  await fetch.post('/mypertamina/v1/admin/transaction/manual/process', payload);

export const manualLoggingSubmissionApprove = async (payload) =>
  await fetch.post('/mypertamina/v1/admin/transaction/manual/approve', payload);

export const manualLoggingSubmissionReject = async (payload) =>
  await fetch.post('/mypertamina/v1/admin/transaction/manual/reject', payload);

export const postAutoApprove = async (payload) =>
  await fetch.post('/mypertamina/v1/admin/automatic-activations', payload);

export const updateStatusManualLoggingActivation = async (
  params = {},
  id = ''
) =>
  await fetch.put(
    `/mypertamina/v1/admin/manual-activation/${id}?status=${params.status}`
  );

export const requestGenerateManualLoggingActivationReport = async (
  params = {}
) =>
  await fetch.get('/mypertamina/v1/admin/download-manual-activation', {
    params,
  });

export const checkGeneratedManualLoggingActivationReport = async (
  cancelToken,
  params = {},
) => {
  return fetch.get(
    '/mypertamina/v1/admin/download-manual-activation/get-file-excel',
    {
      params,
      cancelToken,
    }
  );
};

export const listPermissionUser = async (params) =>
  await fetch.get(USER_PERMISSION_ENDPOINT, { params });

export const userPermissionPost = async (payload) => {
  const modPayload = {
    name: payload.permission,
    path: payload.path,
  };
  return await fetch.post(USER_PERMISSION_ENDPOINT, modPayload);
};

export const userPermissionPut = async (payload) => {
  const modPayload = {
    name: payload.permission,
    path: payload.path,
  };

  return await fetch.put(
    `${USER_PERMISSION_ENDPOINT}/${payload.permissionId}`,
    modPayload
  );
};

export const merchantRegistrationList = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/merchant-registrations', {
    params,
  });
};

export const settingMerchantList = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/merchants', { params });
};

export const settingMerchantSearch = async (params) =>
  await fetch.get('/mypertamina/v2/admin/merchants', { params });

export const settingMerchantDetail = async (registrationId, plantext) =>
  await fetch.get(
    plantext ? `/mypertamina/v1/admin/merchants/${registrationId}` :
      `/mypertamina/v2/admin/merchants/${registrationId}`
  );

export const updateAgen = async (id, payload) => {
  return await fetch.put(
    `/mypertamina/v1/admin/merchants/${id}/agen`,
    payload
  );
};

export const getNotificationDraft = async (params) => {
  return await fetch.get('/notifications/v1/map-notifications', {
    params,
  });
};

export const getLogsSyncMerchant = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/merchants/sync-log', { params });
};

export const getLogsSyncMerchantDetail = async (id) => {
  return await fetch.get(`/mypertamina/v1/admin/merchants/sync-log/${id}`);
};

export const getDownloadLogs = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/merchants/sync-log/download', { params });
};

export const getNotificationActive = async () => {
  return await fetch.get('/notifications/v1/map-notifications/active');
};

export const getDetailNotification = async (id) => {
  return await fetch.get(`/notifications/v1/map-notifications/${id}`);
};

export const postOrderingNotification = async (payload) => {
  return await fetch.post('/notifications/v1/map-notifications/active', payload);
};

export const notificationDelete = async (id) => {
  return await fetch.delete(`/notifications/v1/map-notifications/${id}`);
};

export const postNotification = async (type, payload) => {
  return await fetch.post(`/notifications/v1/map-notifications/${type}`, payload);
};

export const putNotification = async (id, type, payload) => {
  return await fetch.put(`/notifications/v1/map-notifications/${type}/${id}`, payload);
};

export const postNotificationImage = async (payload) => {
  return await fetch.post('/notifications/v1/map-notifications/image', payload);
};

export const postNotificationText = async (payload) => {
  return await fetch.post('/notifications/v1/map-notifications/text', payload);
};

export const suspendMerchant = async (id, payload) => {
  return await fetch.post(
    `/mypertamina/v1/admin/merchants/suspend/${id}`,
    payload
  );
};

export const unsuspendMerchant = async (id, payload) => {
  return await fetch.put(
    `/mypertamina/v1/admin/merchants/unsuspend/${id}`,
    payload
  );
};

export const putBlockPinMerchant = async (id) => {
  return await fetch.put(
    `/mypertamina/v2/admin/merchants/block/${id}`
  );
};

export const identityImage = async (id, payload) => {
  return await fetch.put(`/mypertamina/v1/admin/merchants/${id}/update-identity`, payload);
};

export const editMerchant = async (id, payload) => {
  return await fetch.put(`/mypertamina/v1/admin/merchants/${id}`, payload);
};

export const resendMerchant = async (id) => {
  return await fetch.get(`/mypertamina/v1/admin/merchants/resend/${id}`);
};

export const transactionManualHistory = async (userId, params) => {
  return await fetch.get(
    `/mypertamina/v1/admin/transaction/manual/histories/${userId}`,
    { params }
  );
};

export const deactivateTransactionManual = async (payload) => {
  return await fetch.post(
    '/mypertamina/v1/admin/transaction/manual/deactivate',
    payload
  );
};

export const validateBank = async (params) => {
  return await fetch.get('/mypertamina/v1/bank/validate', { params });
};

export const listBank = async (params) => {
  return await fetch.get(LIST_BANK, { params });
};

export const myptmActivationList = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/myptm-activation', { params });
};

export const myptmActivationLinkAjaDownload = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/myptm-activation/process/download', {
    params,
  });
};

export const myptmActivationFormatDownload = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/myptm-activation/download', {
    params,
  });
};

export const myptmActivationProcess = async (file) => {
  return await fetch.post(
    '/mypertamina/v1/admin/myptm-activation/process',
    file
  );
};

export const myptmActivationManual = async (payload) => {
  return await fetch.post(
    '/mypertamina/v1/admin/myptm-activation/activate',
    payload
  );
};

export const myptmActivationFile = async (payload) => {
  return await fetch.post(
    '/mypertamina/v1/admin/myptm-activation/activate/excel',
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
};

export const listRoleUser = async (params) => {
  return await fetch.get(USER_ROLE_ENDPOINT, { params });
};

export const userRolePost = async (payload) => {
  return await fetch.post(USER_ROLE_ENDPOINT, payload);
};
export const userRolePut = async (payload) => {
  return await fetch.put(`${USER_ROLE_ENDPOINT}/${payload.roleId}`, payload);
};

export const userList = async (params) => {
  return await fetch.get(USER_V2, { params });
};

export const searchUser = async (params) => await fetch.get('/mypertamina/v3/admin/user', { params });

export const detailUser = async (id) => await fetch.get(`/mypertamina/v2/admin/user/${id}`);

export const createUser = async (payload) => {
  return await fetch.post(USER_V3, payload);
};

export const updateUser = async (id, payload) => {
  return await fetch.put(`${USER_V2}/${id}`, payload);
};

export const updateUserPassword = async (id, payload) => {
  return await fetch.put(`${USER}/password/${id}`, payload, { isBearer: true });
};

export const suspendUser = async (payload) =>
  await fetch.put(`/mypertamina/v1/admin/user/suspend`, payload);

export const getQrMfa = async (code) => {
  return await fetch.get(MFA_ENDPOINT, {
    isTempToken: true,
    tempToken: code,
  });
};

export const mfaRegister = async (payload = {}) => {
  return await fetch.post(MFA_ENDPOINT, payload, { isTempToken: true });
};

export const totpVerify = async (payload = {}) =>
  await fetch.post(`${MFA_ENDPOINT}/verify`, payload, { isTempToken: true });

export const totpProtectedResource = async (payload) =>
  await fetch.post(`${MFA_ENDPOINT}/verify/session`, payload);

export const sessionProtectionResource = async () =>
  await fetch.get('/mypertamina/v1/admin/session');

export const changePassword = async (payload) =>
  await fetch.put('/mypertamina/v1/admin/profile/change-password', payload);

export const countdown = async () => await fetch.get('/mypertamina/v1/admin/profile/change-password/countdown');

export const menchantNotOnboarding = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/merchants/pre-onboarding', { params });
};

export const addBusinessType = async (payload, type) => type === '1' ?
  await fetch.post('/mypertamina/v2/business-type', payload) :
  await fetch.post('/mypertamina/v2/business-type/bulk', payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const listBusinessType = async (params) => {
  return await fetch.get('/mypertamina/v2/business-type', { params });
};

export const businessTypeUpdate = async (params, type) => {
  let payload = type === 'PUT' ? {
    name: params.name,
    kbli: params.kbli,
    kbliVersion: params.kbliVersion,
    description: params.description,
  } : {};
  return await fetch({
    url: `/mypertamina/v2/business-type/${params?.id}`,
    method: type,
    data: { ...payload }
  });
};

export const subMerchantActivity = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/subuser/activity/summary', { params });
};

export const subMerchantRegionalActivity = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/subuser/activity', { params });
};

export const subMerchantCountDataCompleted = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/subuser/registered', { params });
};

export const subMerchantCountOnboarding = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/subuser/onboarding', { params });
};

export const subMerchantCountTransaction = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/subuser/transaction', { params });
};

export const subMerchantCountDataXOnBoard = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/subuser/onboarding-difference-registered', { params });
};

export const subMerchantCountTrxXOnBoard = async (params) => {
  return await fetch.get('/mypertamina/v1/admin/subuser/transaction-difference-onboarding', { params });
};

export const updateSubUserRegistrationActivation = async (data) =>
  await fetch.put('/mypertamina/v1/admin/subuser/policies', data);

export const getSubUserPolicies = async (registrationId) =>
  await fetch.get(`/mypertamina/v1/admin/subuser/policies/whitelist?search=${registrationId}`);

export const updatePoliciesBySubUserId = async (payload) =>
  await fetch.post('/mypertamina/v1/admin/subuser/policies/whitelist', payload);

export const uploadBulkSubUserPolicies = async (file) =>
  await fetch.put('/mypertamina/v1/admin/subuser/policies/whitelist/bulk', file, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

// Add these functions after the existing FAQ-related functions

export const saveFaqV2 = async (params = {}) =>
  await fetch.post(`/faqs/v2/myptm/faq`, params);

export const updateFaqV2 = async (id, params = {}) =>
  await fetch.put(`/faqs/v2/myptm/faq/${id}`, params);

export const detailFaqV2 = async (id) =>
  await fetch.get(`/faqs/v2/myptm/faq/${id}`);

export const detailSubMerchant = async (id) =>
  await fetch.get(`/mypertamina/v1/admin/subuser?search=${id}`);

export const maskedDetailSubMerchant = async (id) =>
  await fetch.get(`/mypertamina/v1/admin/subuser/${id}`);

export const plainDetailSubMerchant = async (id) =>
  await fetch.get(`/mypertamina/v1/admin/subuser/plain/${id}`);

export const unblockSubMerchant = async (payload) =>
  await fetch.post(`/mypertamina/subuser-service/v1/unblock`, payload);

export const blockSubMerchant = async (payload) =>
  await fetch.post(`/mypertamina/subuser-service/v1/block`, payload);

export const requestLinkResetPinSubMerchant = async (payload) =>
  await fetch.post(`/mypertamina/subuser-service/v1/forgot-pin`, payload);

export const listAreaManagement = async (params) =>
  await fetch.get(`${AREA_MANAGEMENT_ENDPOINT}/list`, { params });

export const postAreaManagement = async (payload) =>
  await fetch.post(`${AREA_MANAGEMENT_ENDPOINT}`, payload);

export const putAreaManagement = async (id, payload) =>
  await fetch.put(`${AREA_MANAGEMENT_ENDPOINT}/${id}`, payload);

export const deleteAreaManagement = async (id) =>
  await fetch.delete(`${AREA_MANAGEMENT_ENDPOINT}/${id}`);

export const getCustomerDataByNik = async (nationalityId, isMask, yearMonth) => {
  let periodQuery = '';
  if (yearMonth) {
    const [year, month] = yearMonth.split('-');
    periodQuery = `&year=${year}&month=${month}`;
  }

  return await fetch.get(
    '/mypertamina/v1/admin/customer'
    + `?nationalityId=${nationalityId}&isDataMasked=${isMask}${periodQuery}`
  );
};

export const updateNikStatus = async (payload) =>
  await fetch.put(`/mypertamina/v1/admin/customer/block-status`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const updateNikStatusBulk = async (payload) =>
  await fetch.put(`/mypertamina/v1/admin/customer/block-status/batch`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const updateProvinceTransactionRestriction = async (payload) =>
  await fetch.post(`/mypertamina/customers/v1/block-province`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
export const getReasons = async (params) => {
  return await fetch.get('/mypertamina/v1/customer/block-reasons', {
    params,
  });
};

export const getReasonsDetail = async (params) => {
  return await fetch.get('/mypertamina/v1/customer/block-reasons-detail', {
    params,
  });
};

export const createReasonBlock = async (payload) => {
  return await fetch.post(`/mypertamina/v1/customer/block-reasons`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const createReasonDetailBlock = async (payload) => {
  return await fetch.post(`/mypertamina/v1/customer/block-reasons-detail`, payload);
};

export const updateReasonBlock = async (payload) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    key !== 'id' && formData.append(key, value);
  });
  return await fetch.put(`/mypertamina/v1/customer/block-reasons/${payload?.id}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
};

export const updateReasonDetailBlock = async (payload) => {
  return await fetch.put(`/mypertamina/v1/customer/block-reasons-detail/${payload?.id}`,
    { ...payload, id: undefined });
};

export const updateStatusReasonBlock = async (payload) => {
  return await fetch.put(`/mypertamina/v1/customer/block-reasons/${payload?.id}/status`,
    { ...payload, id: undefined });
};

export const updateStatusReasonDetailBlock = async (payload) => {
  return await fetch.put(`/mypertamina/v1/customer/block-reasons-detail/${payload?.id}/status`,
    { ...payload, id: undefined });
};

export const getMerchantListGIGR = async (params) => {
  return await fetch.get('/mypertamina/users/v1/merchants/gi-gr', { params });
};

export const putUpdateStatusMerchantGIGR = async (id, payload) => {
  return await fetch.put(`/mypertamina/users/v1/merchants/gi-gr/${id}`, payload);
};

export const postActivationBulkGIGR = async (file) => {
  return await fetch.post('/mypertamina/users/v1/merchants/gi-gr/bulk', file, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const updateGrMerchant = async () => {
  return await fetch.get(`/mypertamina/v1/goods-receipt/sync`);
};

export const searchCustomerUnblock = async (params) => {
  return await fetch.get(`/mypertamina/customer-service/v1/unblock-request/search`, { params });
};

export const startUnblockCustomer = async () => {
  return await fetch.post(`/mypertamina/customer-service/v1/unblock-request/fifo/process`);
};

export const getSummaryUnblockCustomer = async (params) => {
  return await fetch.get(`/mypertamina/customer-service/v1/unblock-request/summary`, { params });
};

export const processUnblockSubmission = async (requestId, body) => {
  return await fetch
    .post(`/mypertamina/customer-service/v1/unblock-request/${requestId}/approval`, body, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
};

export const processSearchUnblockCustomer = async (body) => {
  return await fetch
    .post(`/mypertamina/customer-service/v1/unblock-request/search/process`, body);
};

export const requestFileDocumentSupport = async (params) => {
  return await fetch
    .get(`
mypertamina/v1/admin/customer/block-support-document`, { params });
};

export const getStatusBulkBatchBlockUnblock = async (id, params) => {
  return await fetch.get(`/mypertamina/v1/admin/customer/block-status/batch${id ? '/' + id : ''}`, {
    params,
  });
};

export const getStatusBulkBlockUnblock = async (id) => {
  return await fetch.get(`/mypertamina/customers/v1/block-batch${id ? '/' + id : ''}`);
};

export const updateFeatureStatusMerchant = async (body) => {
  return await fetch
    .post(`/mypertamina/policy-service/v1/feature-policy`, body);
};

export const getListFeatureMerchant = async () => {
  return await fetch.get(`/mypertamina/policy-service/v1/list-menu`);
};

export const updateFeatureStatusMerchantBulk = async (body) => {
  return await fetch
    .post(`/mypertamina/policy-service/v1/feature-policy/bulk`, body, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
};

export const getInformasiBesaranSubsidi = async (params = {}) => {
  const { page = 1, size = 100, ...restParams } = params;
  return await fetch.get(INFORMATION_SUBSIDY, {
    params: {
      page,
      size,
      ...restParams,
    },
  });
};

export const postInformasiBesaranSubsidi = async (payload) => {
  return await fetch.post(INFORMATION_SUBSIDY, payload);
};

export const deleteInformasiBesaranSubsidi = async (id) => {
  return await fetch.delete(`${INFORMATION_SUBSIDY}/${id}`);
};
